document.addEventListener('DOMContentLoaded', function () {
    const invGridSliders = document.querySelectorAll('.splide.inventory-grid-slider');
    invGridSliders?.forEach((el) => {
        new Splide(el, {
            type: 'loop',
            rewind: true,
            gap: '48px',
            pagination: false,
            fixedWidth: '300px',            
            breakpoints: {
                1240: {
                    width: '95%',
                    focus: 'center',
                }
            }
        }).mount();
    })
});